export default __webpack_public_path__ + "static/media/ss-pika.fcb9f2f1.woff";